// filterByUtils

export function filterBy(filterBy, availableMembers, registeredMembers) {
  if (filterBy == 'registered') {
    availableMembers = _(availableMembers).filter((member) => {
      return !_.find(registeredMembers, {member: member.member, _destroy: false});
    }).value();
  } else if (filterBy == 'not_registered') {
    availableMembers = _(availableMembers).filter((member) => {
      return _.find(registeredMembers, {member: member.member, _destroy: false});
    }).value();
  }
  return availableMembers;
}



/** WEBPACK FOOTER **
 ** ./src/components/common/filterByUtils.js
 **/